/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from "react";
import { useLeafletContext } from '@react-leaflet/core'
import {
  Slider,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import InfoPopUp from "./InfoPopUp";
import Logo from "../Header/Logo";


const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
  "&.Mui-selected": {
    color: "#fff",
    backgroundColor: "#d72864",
     "&:hover": {
      color: "#fff",
      backgroundColor: "#d72864",
     },
   },
   "&:hover": {
    color: "#fff",
    backgroundColor: "#d7286581",
  },
 }));


const CustomSlider = styled(Slider)(({ theme }) => ({
  color: "#d72864",
  "& .MuiSlider-thumb": {
    backgroundColor: "#d72864",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#d72864",
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "#d72864",
    left: '130%',
    width: 20,
    '&::before': {
      display: 'none',
    },
  },
}));


const weekday = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

const min = 480;
const max = 2020;
const step = 20;

const labels = new Set([500, 1000, 1500, 2000]);

const marks = Array.from(
  { length: (max - min) / step + 1 },
  (_, i) => {
    const value = min + i * step;
    return {
      value,
      ...(labels.has(value) && { label: `${value}` }),
    };
  }
);


const HomePanel = (props) => {
  const {
    setDate,
    setUsePrognose,
    setSwitchFogMode,
    currentSliderValue,
    setCurrentSliderValue,
    setFinalSliderValue,
    setPotentialFogTileLayer
  } = props; // date = aktuell gewähltes Datum (vom Parent)
  const [selectedDay, setSelectedDay] = React.useState("today");
  const [loading, setLoading] = useState(false);

  const today = new Date();
  const tomorrow = new Date(today);
  const afterTomorrow = new Date(tomorrow);

  tomorrow.setDate(tomorrow.getDate() + 1)
  afterTomorrow.setDate(afterTomorrow.getDate() + 2)

  const cDayString = weekday[today.getDay()];
  const cDayStringTomorrow = weekday[(today.getDay() + 1) % 7];
  const cDayStringAfterTomorrow = weekday[(today.getDay() + 2) % 7];

  const { map } = useLeafletContext();

  const handleSliderChange = (event, newValue) => {
    map.dragging.disable();
    setCurrentSliderValue(newValue);
  };

  const handleSliderChangeEnd = (event) => {
    map.dragging.enable()
    setFinalSliderValue(currentSliderValue);
  };

  const handleChange = (event, newDay) => {
    document.body.classList.add("loading-cursor");

    if (newDay !== null) {

      setSelectedDay(newDay);
      document.body.style.cursor = "wait";

      const newDate = new Date(today);

      if (newDay === "today") {
        setUsePrognose(true);
        setPotentialFogTileLayer(false);
      } else if (newDay === "tomorrow") {
        newDate.setDate(today.getDate() + 1);
        setUsePrognose(true);
        setPotentialFogTileLayer(false);
      } else if (newDay === "fog_day_after_tomorrow") {
        newDate.setDate(today.getDate() + 2);
        setUsePrognose(true);
        setPotentialFogTileLayer(false);
      } else if (newDay === "potential_fog_height") {
        setUsePrognose(false)
        setPotentialFogTileLayer(true);
      }

      setDate(newDate); 
    }

    setTimeout(() => {
      document.body.classList.remove("loading-cursor");
    }, 3000);
  };


  return (
    <div>
      <div className="display-container">
        <div className="display-title">
          <h1>Nebelkarte Schweiz</h1>
          <Logo className="logo" />
        </div>
        <div className="subtitle">Prognose der Hochnebel-Obergrenze</div>
        <InfoPopUp/>
        <br/>
        <div className="display-bottom">
          <div className="display-content">
            <div className="display-buttons">
              <ToggleButtonGroup
                value={selectedDay}
                exclusive
                onChange={handleChange}
                aria-label="day selection"
              >
                <CustomToggleButton sx={{ 'line-height': '15px', 'padding': '20px 10px', 'text-transform' : 'none' }} value="today">{cDayString} <br /> {today.getDate()}.{(today.getMonth()%13)+ 1}.</CustomToggleButton>
                <CustomToggleButton sx={{ 'line-height': '15px', 'padding': '20px 10px', 'text-transform' : 'none' }} value="tomorrow">{cDayStringTomorrow} <br /> {tomorrow.getDate()}.{(today.getMonth()%13)+ 1}.</CustomToggleButton>
                <CustomToggleButton sx={{ 'line-height': '15px', 'padding': '20px 10px', 'text-transform' : 'none' }} value="fog_day_after_tomorrow">{cDayStringAfterTomorrow} <br /> {afterTomorrow.getDate()}.{(today.getMonth()%13)+ 1}.</CustomToggleButton>
                <Tooltip
                  className="tooltip"
                  title="Selbstangegebene Nebelobergrenze anzeigen"
                  placement="top"
                  arrow
                  slotProps={{ popper: { modifiers: [{ name: 'offset', options: {offset: [0, -7]}}]}}}
                >
                  <CustomToggleButton
                    sx={{ 'line-height': '15px', 'padding': '20px 10px', 'text-transform' : 'none' }}
                    value="potential_fog_height"
                    >
                    Was wäre wenn?
                  </CustomToggleButton>
                </Tooltip>
              </ToggleButtonGroup>
            </div>
          </div>
        </div>
      </div>
      <Stack
        sx={{ height: 300, width: 75, display: selectedDay === "potential_fog_height" ? "flex" : "none" }}
        spacing={2}
        className='slider-panel'
      >
        <Typography id="slider-unit" sx={{ alignSelf: "center" }} >
          m ü.M.
        </Typography>
        <CustomSlider
          sx={{ alignSelf: "flex-start" }}
          className='vertical-slider'
          aria-labelledby="slider"
          value={currentSliderValue}
          orientation='vertical'
          onChange={handleSliderChange}
          onChangeCommitted={handleSliderChangeEnd}
          min={min}
          max={max}
          marks={marks}
          step={step}
          valueLabelDisplay="on"
        />
      </Stack>
    </div>
  );
};

export default HomePanel;
